import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3f3a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(['hz-switch'])
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { isLargeViewPort } from '@remote/utils/base'


export default /*#__PURE__*/_defineComponent({
  props: {
  value: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

// import { ref } from 'vue'
const isPC = isLargeViewPort()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
      'hezi-remote__switch',
      _unref(isPC) ? 'pc_switch' : 'android_switch',
      !!__props.value ? 'hz-switch__on' : 'hz-switch__off',
      { 'is-disabled': __props.disabled },
    ])
  }, _hoisted_2, 2))
}
}

})